import {createFileRoute, notFound, stripSearchParams} from '@tanstack/react-router'
import {type} from 'arktype'
import Base64 from 'crypto-js/enc-base64'
import Utf8 from 'crypto-js/enc-utf8'

import {StoreIdProps} from '@/lib/food/foodModel'
import searchParamString from '@/utils/schema/searchParamString'

const DEFAULT_VALUES = {
  categoryId: '',
}

const indexSearchSchema = type({
  categoryId: searchParamString.default(DEFAULT_VALUES.categoryId),
})

export const Route = createFileRoute('/_food/store/$storeId/')({
  validateSearch: indexSearchSchema,
  search: {
    middlewares: [stripSearchParams(DEFAULT_VALUES)],
  },

  parseParams: (rawParams: Record<string, string>) => {
    const encoded = rawParams.storeId

    try {
      const json = Base64.parse(encoded ?? '').toString(Utf8)

      const parsed = StoreIdProps.assert(JSON.parse(json))

      // eslint-disable-next-line @typescript-eslint/only-throw-error -- ignore
      if (!parsed.id) throw notFound()

      return {
        storeId: parsed,
      }
    } catch {
      // eslint-disable-next-line @typescript-eslint/only-throw-error -- ignore
      throw notFound()
    }
  },

  stringifyParams: (params: {storeId: StoreIdProps}) => {
    const json = JSON.stringify(params.storeId)
    const encoded = Base64.stringify(Utf8.parse(json))

    return {
      storeId: encoded,
    }
  },
})
